// extracted by mini-css-extract-plugin
export var emptyState = "_5h-d";
export var statCard = "_5h-c";
export var table = "_5h-0";
export var tableCell = "_5h-4";
export var tableCellClickable = "_5h-5 _5h-4";
export var tableCellDefault = "_5h-6 _5h-4";
export var tableCellEmpty = "_5h-8";
export var tableCellWithValue = "_5h-7";
export var tableContainer = "_5h-e";
export var tableHeaderWeight = "_5h-1";
export var tableHeaderZone = "_5h-2";
export var tableRowHeader = "_5h-3";
export var viewModeButton = "_5h-9";
export var viewModeButtonActive = "_5h-a _5h-9";
export var viewModeButtonInactive = "_5h-b _5h-9";